import React from 'react'
import { Link } from 'react-router-dom'

import { TopNav } from './TopNav'

export const TopLogo = (): JSX.Element => {
  return (
    <div
      id="app-navbar"
      className="pt-safe-top sticky top-0 z-[100] border-b border-gray-100/90 bg-white px-4 pb-4 sm:px-6 sm:pb-5 lg:px-8"
      style={{
        boxShadow: '0 1px 0 rgba(0,0,0,0.04), 0 8px 24px -8px rgba(0,0,0,0.06)',
      }}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 min-h-[48px] sm:min-h-[52px]">
        <div className="flex min-w-0 flex-1 items-center self-center">
          <Link to="/" className="block h-8 sm:h-10">
            <img className="h-full w-auto" src="/assets/HQ1.png" alt="scrubstr" />
          </Link>
        </div>
        <TopNav />
      </div>
    </div>
  )
}
